import { render } from "./ControledTemp.vue?vue&type=template&id=2daef7cc"
import script from "./ControledTemp.vue?vue&type=script&lang=js"
export * from "./ControledTemp.vue?vue&type=script&lang=js"

import "./ControledTemp.vue?vue&type=style&index=0&id=2daef7cc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__